import { useEffect, useState } from 'react';
import axios from 'axios';

// One lookup per channel per page load, shared by every chat (and remount) showing it
const channelCache = new Map(); // slug -> Promise<channel>

const EMPTY = { broadcasterId: null, chatroomId: null, channelId: null, subBadges: [] };

function fetchChannel(slug) {
  if (!channelCache.has(slug)) {
    const request = axios
      .get(`https://kick.com/api/v2/channels/${slug}`)
      .then(({ data }) => ({
        broadcasterId: data?.user?.id ?? null, // the streamer's user ID (moderation + sending)
        chatroomId: data?.chatroom?.id ?? null,
        channelId: data?.id ?? null, // what Kick's identity endpoint expects
        subBadges: data?.subscriber_badges || [],
      }))
      .catch((err) => {
        channelCache.delete(slug); // allow a retry on the next mount
        throw err;
      });
    channelCache.set(slug, request);
  }
  return channelCache.get(slug);
}

export function useKickChannel(slug) {
  const [channel, setChannel] = useState(EMPTY);

  useEffect(() => {
    if (!slug) return undefined;
    let cancelled = false;
    fetchChannel(slug)
      .then((result) => {
        if (!cancelled) setChannel(result);
      })
      .catch((err) => console.error(`[KickChat] Failed to fetch channel ${slug}:`, err.message));
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return channel;
}
